export type ReactAppConfig = {
  REACT_APP_GTM_CONTAINER_ID: string;
  REACT_APP_GTM_ENV_AUTH: string;
  REACT_APP_GTM_ENV_PREVIEW: string;
  REACT_APP_GA_ID: string;
  GOOGLE_CLIENT_ID: string;
  FACEBOOK_APP_ID: string;
  REACT_APP_POSTHOG_API_KEY: string;
  REACT_APP_POSTHOG_HOST: string;
  REACT_APP_API_URL: string;
};

const getReactAppConfig = (): ReactAppConfig => {
  const host = window.location.hostname;

  const commonConfig = {
    REACT_APP_GTM_CONTAINER_ID: "GTM-P9NRS3G8",
  };

  const configDev = {
    ...commonConfig,
    REACT_APP_GTM_ENV_AUTH: "t9LeOFa3xPP246JZ6VSu6g",
    REACT_APP_GTM_ENV_PREVIEW: "env-2",
    REACT_APP_GA_ID: "G-EYWXV74D9J",
    GOOGLE_CLIENT_ID:
      "177153134144-41s6525mm881v7ubmo0legdi1jtcibkn.apps.googleusercontent.com",
    FACEBOOK_APP_ID: "647342471651341",
    REACT_APP_POSTHOG_API_KEY:
      "phc_J7ZSGqFHphsZQEWvKl8M575GeNkxhQHUlDJTZsp1DT8",
    REACT_APP_POSTHOG_HOST: "https://eu.i.posthog.com",
    REACT_APP_API_URL: "https://api.dev-ibanoplata.com",
  };

  /*const configStg = {
        ...commonConfig,
        REACT_APP_GTM_ENV_AUTH: '23cW4OdixO7ilb82nIF6Nw',
        REACT_APP_GTM_ENV_PREVIEW: 'env-4',
        REACT_APP_GA_ID: 'G-NZ1D8TJCJZ',
    };*/

  const configProd = {
    ...commonConfig,
    REACT_APP_GTM_ENV_AUTH: "5Gt9gWhSh-Lpi0tODXnFXw",
    REACT_APP_GTM_ENV_PREVIEW: "env-1",
    REACT_APP_GA_ID: "G-LBM41CQYK1",
    GOOGLE_CLIENT_ID:
      "138764811603-uvgs1t3ltj4ojckt3dqd9nl93q05i8nt.apps.googleusercontent.com",
    FACEBOOK_APP_ID: "2681219938735335",
    REACT_APP_POSTHOG_API_KEY:
      "phc_pFohDc9uNes2sX53ibbph14r0o3D15MEwhulRzJYqEp",
    REACT_APP_POSTHOG_HOST: "https://eu.i.posthog.com",
    REACT_APP_API_URL: "https://api.ibanoplata.com",
  };

  // Check if the host matches the predefined list
  if (
    host.includes(
      "ibanoplata-web-dev-hwhve5bzaqafaqet.francecentral-01.azurewebsites.net"
    ) ||
    host.includes("dev-ibanoplata.com") ||
    host.includes("localhost")
  ) {
    return configDev;
    /*} else if (host.includes('fopkasa-web-stg.azurewebsites.net')) {
        return configStg;*/
  } else {
    return configProd;
  }
};

export default getReactAppConfig;
